<template>
  <div class="house-card">
    <v-card
      class="mx-auto"
      max-width="400"
      outlined
    >
      <v-img
        class="white--text"
        height="200px"
        :src="`https://source.unsplash.com/featured/?house&sig${getRandom(0, 999)}`"
      >
        <v-card-title class="align-end fill-height">{{ data.name }}</v-card-title>
      </v-img>

      <v-card-text>
        <span>{{ data.city | upperCaseFirst }} - {{ data.zip }}</span><br>
        <span class="text--primary">
        <span>{{ data.address }}</span>
      </span>
      </v-card-text>

      <v-card-actions>
        <v-btn
          text
          :color="statusColor"
        >
          {{ status }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          text
          color="primary"
          :to="`/rooms/${data.id}`"
        >
          Détails
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { filtersCaseMixins } from '@/mixins';

export default {
  name: 'room-card',
  mixins: [filtersCaseMixins],
  computed: {
    status() {
      return this.data.status === 'occupied' ? 'Occupé' : 'Libre';
    },
    statusColor() {
      return this.data.status === 'occupied' ? 'red' : 'green';
    },
  },
  methods: {
    getRandom(min, max) {
      return Math.random() * (max - min) + min;
    },
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
